import * as React from "react";
import cx from "classnames";

import { Color } from "../models";

import "./Color.css";

export interface ColorProps extends Color {
  mini?: boolean;
}

const Color = (props: ColorProps) => (
  <div
    className={cx("color-view__primary", {
      "color-view__primary--mini": props.mini,
    })}
    style={{ background: props.primary_color }}
  >
    <div
      className={cx("color-view__secondary", {
        "color-view__secondary--mini": props.mini,
      })}
      style={{ background: props.secondary_color }}
    />
  </div>
);

export default Color;



// WEBPACK FOOTER //
// ./src/components/Color.tsx